import { darken } from "polished";
import styled from "styled-components";
import logoConfirm from "../../assets/confirmation-icon.svg";
import xIcon from "../../assets/x-icon.svg";
import logoOutlineConfirm from "../../assets/confirmation-outline-icon.svg";
import "../../styles/sass/Pages/_newDesign.scss";

export const Container = styled.div`
	width: 100%;
	height: 100%;
	display: flex;
	align-items: center;
	justify-content: center;
	font-family: "Metropolis";

	@media only screen and (max-width: 900px) {
		flex-direction: column;
		justify-content: flex-start;
	}
`;

export const Content = styled.div`
	display: flex;
	align-items: flex-start;
	justify-content: space-between;
	flex-direction: column;
	padding: 30px;
	background: #23242f;
	width: 41rem;
	height: 18rem;
	border-radius: 8px;

	@media only screen and (max-width: 900px) {
		background: #13141b;
		height: 28rem;
		width: 23rem;
		padding: 0;
		position: absolute;
		top: 9rem;
		justify-content: space-evenly;
	}

	@media only screen and (max-width: 380px) {
		height: 25rem;
		width: 20rem;
		top: 7rem;
	}
`;

export const Header = styled.div`
	display: flex;
	flex-direction: row;
	width: 100%;
	height: 3rem;
	background-repeat: no-repeat;
	background-image: url(${logoConfirm});

	@media only screen and (max-width: 900px) {
		background-image: url(${logoOutlineConfirm});
		height: 7rem;
		background-position: center;
	}
`;

export const CloseButton = styled.div`
	background-color: transparent;
	background-repeat: no-repeat;
	background-image: url(${xIcon});
	cursor: pointer;
	width: 100%;
	height: 1rem;
	background-position: right;
	outline: none !important;

	@media only screen and (max-width: 900px) {
		background-image: none;
		height: 0;
	}
`;

export const Title = styled.label`
	color: #ffffff;
	font-size: 24px;
	font-family: var(--font-family-metropolis-semi-bold);
	margin-top: 8px;
	margin-bottom: 24px;

	@media only screen and (max-width: 900px) {
		text-align: center;
		padding: 0 30px;
	}
`;

export const Subtitle = styled.label`
	color: #ffffff;
	font-size: 16px;
	font-family: "MetropolisRegular";
	margin-bottom: 0;

	@media only screen and (max-width: 900px) {
		display: none;
	}
`;

export const ButtonConfirm = styled.div`
	cursor: pointer;
	left: 12.6rem;
	width: 12rem;
	height: 40px;
	margin-top: 40px;
	border-radius: 8px;
	position: relative;
	display: flex;
	align-self: center;
	align-items: center;
	justify-content: center;
	background-color: #01e59b;
	color: #13141b;
	border: 0px;
	font-size: 16px;
	font-family: var(--font-family-metropolis-semi-bold);

	&:hover {
		background: ${darken(0.03, "#01E59B")};
	}

	@media only screen and (max-width: 900px) {
		left: 0;
		width: 100%;
	}
`;
